import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from './banner.component';
import { IconModule } from '../icon/icon.module';
import { ModalOpenerModule } from '../modal-opener/modal-opener.module';
import { BackgroundImageDirective } from './background-image.directive';



@NgModule({
  declarations: [BannerComponent, BackgroundImageDirective],
  imports: [
    CommonModule,
    IconModule,
    ModalOpenerModule
  ],
  exports: [BannerComponent]
})
export class BannerModule { }
